import React, { useContext, useEffect, useRef, useState } from "react";

import style from "./HeaderCategorySelector.module.css";
import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { UserContext } from "../../../Context/UserContextProvider";
import FilterModal from "../../../Dashboard/DashboardFileManagement/FilterModal/FilterModal";
import { Helmet } from "react-helmet";

export default function HeaderCategorySelector(props) {
  const { userToken } = useContext(UserContext);
  const navigate = useHistory();

  let [categoriesData, setCategoriesData] = useState([]);

  useEffect(() => {
    axios
      .get("Category", {
        headers: {
          authorization: "Bearer " + userToken,
        },
      })
      .then(res => {
        setCategoriesData(res.data.data);
      });
  }, []);

  let [dealTypeMenu, openDealTypeMenu] = useState(false);
  let [useTypeMenu, openUseTypeMenu] = useState(false);
  let [propertyTypeMenu, openPropertyTypeMenu] = useState(false);
  let [regionsMenu, openRegionsMenu] = useState(false);

  let dealTypeMenuRef = useRef();
  let useTypeMenuRef = useRef();
  let propertyTypeMenuRef = useRef();
  let regionsMenuRef = useRef();

  let [showFilter, setShowFilter] = useState(false);

  let [selectedDealType, setSelectedDealType] = useState(props?.dealType || 0);
  let [selectedUseType, setSelectedUseType] = useState(props?.useType || 0);
  let [selectedPropertyType, setSelectedPropertyType] = useState(props?.propertyType || 0);
  let [selectedRegions, setSelectedRegions] = useState(props?.regions || []);

  let [description, setDescription] = useState("");
  let [title, setTitle] = useState("");
  let [headerData, setHeaderData] = useState({
    title: "",
    meta: {
      description: "",
      index: false,
    },
  });

  useEffect(() => {
    axios
      .get(
        `LandingDescription?DealType=${selectedDealType}${selectedUseType != 0 ? "&UseType=" + selectedUseType : ""}${
          selectedPropertyType != 0 ? "&PropertyType=" + selectedPropertyType : ""
        }${selectedRegions.length != 0 ? "&Region=" + selectedRegions[0] : ""}`
      )
      .then(res => {
        setDescription(res.data.description);
        setTitle(res.data.title);
        setHeaderData({
          title: res.data.pageTitle,
          meta: {
            title: res.data.metaTitle,
            description: res.data.metaDescription,
            index: res.data.indexPage,
          },
        });
      });
  }, [selectedDealType, selectedUseType, selectedPropertyType, selectedRegions]);

  let [useTypeCategories, setuseTypeCategories] = useState([]);
  let [propertyTypeCategories, setPropertyTypeCategories] = useState([]);
  let [regionCategories, setRegionCategories] = useState([]);

  function mouseDownEvent(ev) {
    if (!useTypeMenuRef.current.contains(ev.target)) {
      openUseTypeMenu(false);
    }

    if (!propertyTypeMenuRef.current.contains(ev.target)) {
      openPropertyTypeMenu(false);
    }

    if (!regionsMenuRef.current.contains(ev.target)) {
      openRegionsMenu(false);
    }
  }

  useEffect(() => {
    window.addEventListener("mousedown", mouseDownEvent);

    return () => {
      window.removeEventListener("mousedown", mouseDownEvent);
    };
  }, []);

  useEffect(() => {
    if (props.dealType != undefined) {
      setSelectedDealType(props.dealType == -1 ? 0 : props.dealType || 0);
    }
    if (props.useType != undefined) {
      setSelectedUseType(props.useType);
    }
    if (props.propertyType != undefined) {
      setSelectedPropertyType(props.propertyType);
    }
    if (props.regions != undefined) {
      setSelectedRegions(props.regions);
    }
  }, [props]);

  function selectDealType(type) {
    setSelectedDealType(type);
  }

  function selectUseType(type) {
    if (selectedUseType == type) {
      setSelectedUseType(0);
      setSelectedRegions([]);
      setSelectedPropertyType(0);
      openUseTypeMenu(false);
      return;
    }

    setSelectedUseType(type);
    setSelectedRegions([]);
    setSelectedPropertyType(0);
    openUseTypeMenu(false);
  }

  function selectPropertyType(property) {
    if (selectedPropertyType == property) {
      setSelectedRegions([]);
      setSelectedPropertyType(0);
      openPropertyTypeMenu(false);
      return;
    }

    setSelectedPropertyType(property);
    setSelectedRegions([]);
    openPropertyTypeMenu(false);
  }

  function checkSelectedRegions(region) {
    let cacheArray = [];
    let didExist = false;

    if (selectedRegions[0] != region) {
      cacheArray = [region];
    }

    /*selectedRegions.forEach((r) => {
            if (region == r){
                didExist = true;
            }else{
                cacheArray.push(r);
            }
        });

        if (!didExist){
            cacheArray.push(region);
        }*/

    openRegionsMenu(false);
    setSelectedRegions(cacheArray);
  }

  useEffect(() => {
    let cacheArray = [];

    categoriesData.forEach(category => {
      if (category.dealType == selectedDealType && category.parentId == null) {
        cacheArray.push(category);
      }
    });

    setuseTypeCategories(cacheArray);
  }, [categoriesData, selectedDealType]);

  useEffect(() => {
    let cacheArray = [];

    categoriesData.forEach(category => {
      if (category.parentId == selectedUseType) {
        cacheArray.push(category);
      }
    });

    setPropertyTypeCategories(cacheArray);
  }, [selectedUseType, useTypeCategories]);

  useEffect(() => {
    let cacheArray = [];

    categoriesData.forEach(category => {
      if (category.parentId == selectedPropertyType) {
        cacheArray.push(category);
      }
    });

    setRegionCategories(cacheArray);
  }, [selectedPropertyType, propertyTypeCategories]);

  function submitButton() {
    let useType = "";
    let propertyType = "";
    let region = "";

    if (selectedUseType != 0) {
      useType =
        categoriesData
          .find(c => c.id == selectedUseType)
          ?.title.replace(/ /g, "-")
          .replace("/", "-") + "/" || "/";
    }
    if (selectedPropertyType != 0) {
      propertyType =
        categoriesData
          .find(c => c.id == selectedPropertyType)
          ?.title.replace(/ /g, "-")
          .replace("/", "-") + "/" || "/";
    }
    if (selectedRegions.length != 0) {
      region =
        categoriesData
          .find(c => c.id == selectedRegions[0])
          ?.title.replace(/ /g, "-")
          .replace("/", "-") + "/" || "/";
    }

    let text = "";

    switch (selectedDealType) {
      case 0:
        text = "خرید/";
        break;
      case 1:
        text = "رهن-و-اجاره/";
        break;
      case 2:
        text = "پیش-فروش/";
        break;
      case 3:
        text = "مشارکت/";
        break;
    }

    navigate.push("/", {
      redirect: "/فایل-ها/" + text + useType + propertyType + region,
      redirectData: {
        dealType: selectedDealType,
        propertyType: selectedPropertyType,
        useType: selectedUseType,
        region: selectedRegions,
      },
    });
  }

  function dealTypeText() {
    switch (selectedDealType) {
      case 0:
        return "خرید";
      case 1:
        return "رهن و اجاره";
      case 2:
        return "پیش فروش";
      case 3:
        return "مشارکت";
    }
  }

  function titleText() {
    let title = "";

    switch (selectedDealType) {
      case 0:
        title += "خرید و فروش";
        break;
      case 1:
        title += "رهن و اجاره";
        break;
      case 2:
        title += "پیش فروش";
        break;
      case 3:
        title += "مشارکت";
        break;
    }

    if (selectedPropertyType != 0) {
      title += " " + (categoriesData.find(c => c.id == selectedPropertyType)?.title || "");
    }

    if (selectedRegions.length > 0) {
      title += " در " + (categoriesData.find(c => c.id == selectedRegions[0])?.title || "");
    }

    return title;
  }

  console.log("category", showFilter, useTypeCategories, propertyTypeCategories, categoriesData);

  return (
    <div className={`${style.container}`}>
      <Helmet>
        {headerData.title != "" ? (
          <title>{headerData.title}</title>
        ) : headerData.title != "" ? (
          <title>{headerData.title}</title>
        ) : (
          <title>Azar Melk | آذر ملک</title>
        )}
        {headerData.meta.description != "" ? <meta name="description" content={headerData.meta.description}></meta> : null}
        <meta content={headerData.meta.index ? "index , follow" : "noindex , nofollow"} name="robots" />
      </Helmet>
      <FilterModal
        show={showFilter}
        filterParams={props.filterParams}
        dataHandler={props.dataHandler}
        setFilterParams={props.setFilterParams}
        filterCardsByCategory={selectedDealType == 1 ? "" : "onSale"}
        deleteFilterHandler={props.dataHandler}
        onHide={() => {
          setShowFilter(false);
          // console.log("Hello");
        }}
      />
      <div className={`${style.categories_container}`}>
        <div className={`${style.categories_buttons}`}>
          {/*<div className={`${style.category_button}`} ref={dealTypeMenuRef}>
                    <div className={`${style.category_button_header}`} onClick={() => {openDealTypeMenu(true)}}>
                        {
                            dealTypeText() || "نوع معامله"
                        }
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{width: "20px", height: "20px"}}><path d="M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z"/></svg>
                    </div>
                    <div className={`${style.category_button_items}`} hidden={!dealTypeMenu}>
                        <div className={`${style.category_button_item} ${selectedDealType == 0? style.category_button_item_active : ""}`} onClick={() => selectDealType(0)}>
                            خرید
                        </div>
                        <div className={`${style.category_button_item} ${selectedDealType == 1? style.category_button_item_active : ""}`} onClick={() => selectDealType(1)}>
                            رهن و اجاره
                        </div>
                        <div className={`${style.category_button_item} ${selectedDealType == 2? style.category_button_item_active : ""}`} onClick={() => selectDealType(2)}>
                            پیش فروش
                        </div>
                        <div className={`${style.category_button_item} ${selectedDealType == 3? style.category_button_item_active : ""}`} onClick={() => selectDealType(3)}>
                            مشارکت
                        </div>
                    </div>
                </div>*/}
          <div className={`${style.category_button}`} ref={useTypeMenuRef}>
            <div
              className={`${style.category_button_header}`}
              onClick={() => {
                openUseTypeMenu(true);
              }}>
              {selectedUseType == 0 ? (
                <p>نوع کاربری</p>
              ) : (
                <p>{useTypeCategories.find(c => c.id == selectedUseType)?.title || "نوع کاربری"}</p> || <p>نوع کاربری</p>
              )}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: "20px", height: "20px" }}>
                <path d="M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z" />
              </svg>
            </div>
            <div className={`${style.category_button_items}`} hidden={!useTypeMenu}>
              {useTypeCategories.map(category => {
                return (
                  <div
                    className={`${style.category_button_item} ${category.id == selectedUseType ? style.category_button_item_active : ""}`}
                    onClick={() => selectUseType(category.id)}>
                    {category.title}
                  </div>
                );
              })}
            </div>
          </div>
          <div className={`${style.category_button}`} ref={propertyTypeMenuRef}>
            <div
              className={`${style.category_button_header} ${selectedUseType == 0 ? style.category_button_header_inactive : ""}`}
              onClick={ev => {
                selectedUseType == 0 ? ev.preventDefault() : openPropertyTypeMenu(true);
              }}>
              {selectedPropertyType == 0 ? (
                <p>نوع ملک</p>
              ) : (
                <p>{propertyTypeCategories.find(c => c.id == selectedPropertyType)?.title || "نوع ملک"}</p> || <p>نوع ملک</p>
              )}
              <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" viewBox="0 0 448 512" style={{ width: "20px", height: "20px" }}>
                <path d="M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z" />
              </svg>
            </div>
            <div className={`${style.category_button_items}`} hidden={!propertyTypeMenu}>
              {propertyTypeCategories.map(category => {
                return (
                  <div
                    className={`${style.category_button_item} ${category.id == selectedPropertyType ? style.category_button_item_active : ""}`}
                    onClick={() => selectPropertyType(category.id)}>
                    {category.title}
                  </div>
                );
              })}
            </div>
          </div>
          <div className={`${style.category_button}`} ref={regionsMenuRef}>
            <div
              className={`${style.category_button_header} ${selectedPropertyType == 0 ? style.category_button_header_inactive : ""}`}
              onClick={ev => {
                selectedPropertyType != 0 ? openRegionsMenu(true) : ev.preventDefault();
              }}>
              {selectedRegions.length == 0 ? <p>منطقه</p> : <p>{regionCategories.find(c => c.id == selectedRegions[0])?.title || "منطقه"}</p> || <p>منطقه</p>}
              <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" viewBox="0 0 448 512" style={{ width: "20px", height: "20px" }}>
                <path d="M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z" />
              </svg>
            </div>
            <div className={`${style.region_button_items}`} hidden={!regionsMenu}>
              {regionCategories.map(category => {
                return (
                  <div
                    className={`${style.region_button_item}`}
                    onClick={() => {
                      checkSelectedRegions(category.id);
                    }}>
                    <input type="checkbox" checked={selectedRegions.includes(category.id)}></input>
                    <p className={`${style.region_button_item_title}`}>{category.title}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className={`${style.search_container}`}>
          <div className={`${style.filter_button}`}>
            <div
              className={`${style.filter_button_icon}`}
              onClick={() => {
                setShowFilter(true);
              }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: "20px", height: "20px" }}>
                <path d="M0 73.7C0 50.7 18.7 32 41.7 32H470.3c23 0 41.7 18.7 41.7 41.7c0 9.6-3.3 18.9-9.4 26.3L336 304.5V447.7c0 17.8-14.5 32.3-32.3 32.3c-7.3 0-14.4-2.5-20.1-7l-92.5-73.4c-9.6-7.6-15.1-19.1-15.1-31.3V304.5L9.4 100C3.3 92.6 0 83.3 0 73.7zM55 80L218.6 280.8c3.5 4.3 5.4 9.6 5.4 15.2v68.4l64 50.8V296c0-5.5 1.9-10.9 5.4-15.2L457 80H55z" />
              </svg>
            </div>
          </div>
          <div className={`${style.search_button}`} onClick={submitButton}>
            جست و جو
          </div>
        </div>
      </div>
      <div className={`${style.header_container}`}>
        <h1 className={`${style.title}`}>{title == "" ? titleText() : title}</h1>
        <div className={`${style.description}`}>{description}</div>
      </div>
    </div>
  );
}
